import { invokeApi } from "../../bl_libs/invokeApi";

/** Recipient count + sample names for an audience `target`. */
export const previewGeneralNotificationApi = async (target) => {
  const requestObj = {
    path: `/api/notification/general/preview`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: { target },
  };
  return invokeApi(requestObj);
};

/** Sends an in-app notification: { title, message, target }. */
export const sendGeneralNotificationApi = async (data) => {
  const requestObj = {
    path: `/api/notification/general/send`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

/** Sent notifications history (page is 0-based). */
export const generalNotificationHistoryApi = async (page = 0, limit = 10) => {
  const requestObj = {
    path: `/api/notification/general/history?page=${encodeURIComponent(
      page
    )}&limit=${encodeURIComponent(limit)}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
